import { useApi } from '@src/app/context/Api';
import { AddEidButton } from '@src/features/ActionPaths/AddEid';
import { RemoveEidModal } from '@src/features/ActionPaths/RemoveEid';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import React, { useState } from 'react';

import { Table } from './components/Table';

/**
 * Widget: AssociatedEids
 *
 * Allows adding/removing EID's to/from an active/manual action path.
 *
 * @param actionPath
 * @returns {Element}
 * @constructor
 */
export function AssociatedEids({ actionPath = {} }) {
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [eids, setEids] = useState([]);

  const { useApiQuery } = useApi('RiskRecord');

  const [ListRiskRecords, { data: riskRecords, error, isFetching, isLoading, refetch }] =
    useApiQuery('ListRiskRecords');

  return (
    <ErrorHandler location="src/widgets/ActionPaths/AssociatedEids/AssociatedEids.jsx">
      <LoadingOverlay
        ariaLoadingLabel="Your request is being processed."
        isLoading={isLoading || isFetching}
        loadingMessage="Your request is being processed."
        loadingTitle="Loading..."
      >
        <Widget
          button={<AddEidButton actionPath={actionPath} refetch={refetch} />}
          description="Other Entities that this record is connected to"
          title="Assosciated EID's"
        >
          <Table
            error={error}
            isLoading={isLoading || isFetching}
            refetch={refetch}
            requestArgs={{
              criteria: {
                entrance: {
                  additional: [
                    {
                      column: 'ACTION_PATH_ID',
                      condition: 'EQ',
                      value: actionPath?.id,
                    },
                  ],
                },
              },
              page: 0,
              size: 5,
              sort: 'eid,asc',
            }}
            requestFunction={ListRiskRecords}
            requestKey="ListRiskRecords"
            rows={riskRecords?.content || []}
            setEids={setEids}
            setIsOpen={setShowRemoveModal}
            totalPages={riskRecords?.totalPages || 1}
            totalRecords={riskRecords?.totalElements || 0}
          />
        </Widget>
      </LoadingOverlay>
      <RemoveEidModal
        actionPath={actionPath}
        eids={eids}
        isOpen={showRemoveModal}
        refetch={refetch}
        setEids={setEids}
        setIsOpen={setShowRemoveModal}
      />
    </ErrorHandler>
  );
}
